import { inject, Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";

export interface ScnackbarData {
  title?: string,
  message?: string
  style?: SnackbarStyles
  iconName?: string,
  autoClose?: boolean
}

export enum SnackbarStyles {
  Success = "success",
  Error = "error",
  Warning = "warning",
  Info = "info"
}
@Injectable({
  providedIn: 'root'
})
export class ToastService {
  toast = inject(ToastrService)
  constructor(
  ) {

  }

  /*
  error: 'toast-error',
  info: 'toast-info',
  success: 'toast-success',
  warning: 'toast-warning',
  **/
  show(data: ScnackbarData) {
    const config = {
      disableTimeOut: data.autoClose,
      closeButton: !data.autoClose
    }
    switch (data.style) {
      case SnackbarStyles.Success:
        this.toast.success(data.message, data.title, config);
        break;
      case SnackbarStyles.Error:
        this.toast.error(data.message, data.title, config);
        break;
      case SnackbarStyles.Warning:
        this.toast.warning(data.message, data.title, config);
        break;
      default:
        this.toast.info(data.message, data.title, config);
        break;
    }
  }
}


